var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"validate-on-blur":_vm.validateOnBlur,"outlined":_vm.outlined,"dense":_vm.dense,"menu-props":{ offsetY: true, maxHeight: 170 }},scopedSlots:_vm._u([(_vm.translateItems)?{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t(item.key))+" ")])],1)]}}:null,(_vm.translateItems)?{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(item.key))+" ")]}}:null],null,true)},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }